module.exports = ".dialog-loader{text-align:center}.btn.btn-blue{color:#fff}@keyframes ui-progress-spinner-color{100%,0%{stroke:#2e68b1}40%{stroke:#2e68b1}66%{stroke:#2e68b1}80%,90%{stroke:#2e68b1}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings-employee-edit-history/employee-edit-history-add-modal/employee-edit-history-add-modal.component.scss
// module id = 470
// module chunks = 0